<template>
  <div
    class="bg-background-neutral-secondary relative space-y-4 rounded-2xl pb-3"
  >
    <SeatMapColumns class="sticky top-0" :cols="mappedSeatMap.cols" />
    <div v-for="(row, i) in mappedSeatMap.rows" :key="i" class="px-4">
      <SeatMapRow
        :row="row"
        :max-seats-in-row="maxSeatsInRow"
        :seat-map-legend="seatMapLegend"
        :seat-map-state="segmentState"
        :passengers-keys="passengersKeys"
        :active-passenger-key="activePassengerKey"
        @onSelect="emit('onSeatSelect', $event)"
        @onUnselect="emit('onUnselectSeat')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { PassengerKey } from '@aviata/booking-data';

  import SeatMapRow from './SeatMapRow.vue';
  import SeatMapColumns from './SeatMapColumns.vue';
  import type { SerializedSeatmap } from '../lib';
  import type { PassengersState, SeatMapLegend, SelectedSeat } from '../types';

  defineProps<{
    mappedSeatMap: SerializedSeatmap;
    maxSeatsInRow: number;
    seatMapLegend: SeatMapLegend;
    segmentState: PassengersState;
    passengersKeys: PassengerKey[];
    activePassengerKey: PassengerKey;
  }>();

  const emit = defineEmits<{
    onSeatSelect: [SelectedSeat];
    onUnselectSeat: [];
  }>();
</script>
